import { render, staticRenderFns } from "./ordinaryUser.vue?vue&type=template&id=11d64e86&scoped=true&"
import script from "./ordinaryUser.vue?vue&type=script&lang=js&"
export * from "./ordinaryUser.vue?vue&type=script&lang=js&"
import style0 from "./ordinaryUser.vue?vue&type=style&index=0&id=11d64e86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d64e86",
  null
  
)

export default component.exports